class ProductCardQuickShop extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.querySelectorAll('[js-add-to-cart]').forEach((t) => {
      t.addEventListener('click', this.addToCart.bind(this, t));
    });
    const t = this.querySelector('[js-quick-shop]');
    t?.addEventListener('click', this.showOptions.bind(this));
  }
  async addToCart(t) {
    const i = t.getAttribute('data-variant-id');

    try {
      if (!window.theme?.addToCart) {
        // Fallback: Try using shopifyUtils directly
        if (window.shopifyUtils?.addToCart) {
          await window.shopifyUtils.addToCart({
            items: [{ id: i, quantity: 1 }]
          });

          const basketElement = document.querySelector('.c-header__basket');
          if (basketElement) {
            basketElement.click();
          }
          return;
        }

        console.error('No cart methods available');
        return;
      }

      await window.theme.addToCart([{ id: i, quantity: 1 }]);

    } catch (error) {
      console.error('Error in addToCart:', error);
    }
  }
  showOptions() {
    this.classList.add('active');
  }
}
customElements.get('product-card-quick-shop') ||
  customElements.define('product-card-quick-shop', ProductCardQuickShop);
